import { createContext, useContext, useState } from "react";
import http from "../helpers/http";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import axios from "axios";
import { getBaseUrl } from "../helpers/http"
const getDomainFromUrl = () => {
  const { hostname } = window.location;

  // Ignore localhost & IPs
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    /^\d+\.\d+\.\d+\.\d+$/.test(hostname)
  ) {
    return null;
  }

  const cleanHost = hostname.replace(/^www\./, "");
  const firstPart = cleanHost.split(".")[0];

  // Only allow tenant when dash exists
  if (!firstPart.includes("-")) {
    return null;
  }

  const [tenant] = firstPart.split("-");

  return tenant || null;
};

export const Authprovider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Load user data from local storage upon component initialization
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : {};
  });
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [globalProfile, setGlobalProfile] = useState(user?.profile);
  const [editId, setEditId] = useState("");

  const login = async (email, password) => {
    setLoading(true);
    try {
      const domain = getDomainFromUrl();
      const response = await axios.post(
        `${getBaseUrl()}/account/login`,
        {
          Username: email,
          Password: password,
        },
        {
          headers: {
            "ngrok-skip-browser-warning": "true",
            "Content-Type": "application/json",
            ...(domain && { "X-Domain": domain }),
          },
        },
      );

      if (response.data) {
        localStorage.setItem("token", response.data.data.accessToken);
        localStorage.setItem("user", JSON.stringify(response.data.data));
        setIsLoggedIn(true);
        setUser(response.data.data);
        setToken(response.data.data.accessToken);
        setGlobalProfile(response.data.data.profile);
        setLoading(false);
        navigate("/dashboard");
      }
    } catch (error) {
      if (error.response) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        setUser,
        isLoggedIn,
        token,
        loading,
        isModalOpen,
        setIsModalOpen,
        globalProfile,
        setGlobalProfile,
        setEditId,
        editId,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};